<template>
    <BaseModal :class-name="'ListItemModal'"
               :title="id?name:'LIST__NEW_ITEM'"
               @save="save"
               @close="close">
        <div class="ListItemModal__body">

            <!--DELETE-->
            <div v-if="id" class="ListItemModal__delete-container">
                <BaseButtonFlat :label="'COMMON__DELETE'"
                                :class-name="'ListItemModal__delete'"
                                @click="confirmDeleteItem()" />
            </div>

            <!--NAME-->
            <BaseText :label="'LIST__NAME'"
                      :value="name"
                      :errors="errors['name']"
                      @change="setName($event.target.value)" />

            <!--SEX-->
            <BaseSegmented :value="sex"
                           :items="sexes"
                           @change="setSex" />

        </div>
    </BaseModal>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import BaseModal from '../common/BaseModal.vue';
    import BaseButtonFlat from '../common/BaseButtonFlat.vue';
    import BaseText from '../common/BaseText.vue';
    import BaseSegmented from '../common/BaseSegmented.vue';

    export default {
        name: 'ListItemModal',
        components: {
            BaseModal,
            BaseButtonFlat,
            BaseText,
            BaseSegmented
        },
        computed: {
            ...mapState({
                id: s => s.listItem.id,
                name: s => s.listItem.name,
                sex: s => s.listItem.sex,
                sexes: s => s.listItem.sexes,
                errors: s => s.listItem.errors
            })
        },
        methods: {
            ...mapActions({
                close: 'listItem/close',
                save: 'listItem/save',
                confirmDeleteItem: 'listItem/confirmDeleteItem',
                //Setters
                setName: 'listItem/setName',
                setSex: 'listItem/setSex'
            }),
            ...mapGetters({
                getStateString: 'form/getStateString'
            })
        }
    };
</script>

<style>
    .BaseModal.ListItemModal {
        width: 400px;
    }

    .ListItemModal__delete-container {
        display: flex;
        justify-content: flex-end;
    }

    .BaseButtonFlat.ListItemModal__delete {
        color: #e64a19;
    }
</style>



// WEBPACK FOOTER //
// ListItemModal.vue?04fe67e8